import { render, staticRenderFns } from "./lowerB.vue?vue&type=template&id=03c47e25&"
import script from "./lowerB.vue?vue&type=script&lang=js&"
export * from "./lowerB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports